/**
 * ========== options ==========
 * field_name: 필드명 ( 사용하는 곳은 없으나, 개발자가 구분하기 위해 작성한다 )
 * field_code: 필드 코드 ( ** 매우 중요, field 등록시 사용되는 code 값  )
 * label: 탭 이름 ( 실제표기는 `${label} 등록`, `${label} 현황` 로 사용된다.)
 * useInfo: 두번째 현황 탭을 사용할지 여부 ( true: 사용, false: 사용안함 )
 *   - useInfo 를 사용하기 위해서는 field_code 와 동일한 이름의 폴더를 생성하고, 그 안에 Info.vue 를 생성해야 한다.
 * useExcelUpload: 엑셀 업로드 탭을 사용할지 여부 ( true: 사용, false: 사용안함 )
 *   - useExcelUpload 를 사용하기 위해서는 field_code 와 동일한 이름의 폴더를 생성하고, 그 안에 ExcelUpload.vue 를 생성해야 한다.
 * showOneTab: 탭을 하나만 사용할 때 탭을 노출할지 여부, useInfo 와 관련이 있다. ( true: 사용, false: 사용안함 )
 * =============================
 */
export default {
  '_test_field_code': {
    field_name: "직영사업장", field_code: '_test_field_code',
    label: '사업장', useInfo: true, showOneTab: false,
  },
  'workplace-insider': {
    field_name: "직영사업장", field_code: 'workplace-insider',
    label: '사업장', useInfo: true, showOneTab: false,
  },

  'workplace-subcontract': {
    field_name: "도급·용역·위탁 사업장", field_code: 'workplace-subcontract',
    label: '사업장', useInfo: true, showOneTab: false,
  },

  'workplace-ordering': {
    field_name: "발주 사업장", field_code: 'workplace-ordering',
    label: '사업장', useInfo: true, showOneTab: false,
  },

  'facility': {
    '5.field_name': "공중이용시설",
    '5.label': "공중이용시설",
    field_name: "시설물", field_code: 'facility',
    label: '시설', useInfo: true, showOneTab: false,
  },

  'warehouse': {
    field_name: "창고", field_code: 'warehouse',
    label: '창고', useInfo: true, showOneTab: false,
  },

  'bridge': {
    field_name: "교량", field_code: 'bridge',
    label: '교량', useInfo: false, showOneTab: false,
  },

  'retaining-wall': {
    field_name: "옹벽", field_code: 'retaining-wall',
    label: '옹벽', useInfo: false, showOneTab: false,
  },

  'dike': {
    field_name: "제방", field_code: 'dike',
    label: '제방', useInfo: false, showOneTab: false,
  },

  'government-building': {
    field_name: "청사", field_code: 'government-building',
    label: '청사', useInfo: false, showOneTab: false,
  },

  'complex-facility': {
    field_name: "복합시설", field_code: 'complex-facility',
    label: '복합시설', useInfo: false, showOneTab: false,
  },

  'public-transportation': {
    field_name: "공중교통수단", field_code: 'public-transportation',
    label: '공중교통수단', useInfo: true, showOneTab: false,
  },

  'workplace-material': {
    '5.field_name': "원료·제조물 사업장",
    '5.label': "원료·제조물 사업장",
    field_name: "원료·제조물 사업장", field_code: 'workplace-material',
    label: '사업장', useInfo: true, showOneTab: false,
  },

  'facility-public': {
    field_name: "공중(다중)이용시설", field_code: 'facility-public',
    label: '공중(다중)이용시설', useInfo: true, showOneTab: false,
  },

}
